export function Identity(x) {
  return x;
};

export function Noop() {};

export function valOrEval (value) {
  if (typeof value === 'function') {
    var evalArgs = Array.prototype.slice.call(arguments, 1);
    return value.apply(this, evalArgs);
  } else {
    return value;
  }
};

export function tryCallback(callback, ...args) {
  if (typeof callback === 'function') {
    callback(...args);
  }
}

export function callAsPromise(fn, ...args) {
  return new Promise((resolve, reject) => {
    try {
      fn(...args, resolve)
    } catch (e) {
      reject(e);
    }
  });
}



// WEBPACK FOOTER //
// ./lib/rlink-utils/functional.js